<template>
  <list
    row-key="InstanceId"
    ref="list"
    :page="page"
    :query-params="params"
    :show-checkbox="false"
    :show-query="showQuery"
    :get-data-func="api.list"
    @reset="$refs.picker.clear()"
    expand-all-row
  >
    <template slot="toolbar-right">
      <slot name="toolbar-right"></slot>
    </template>
    <template slot="query">
      <el-form-item label="申请人">
        <el-input v-model="params.ApplyEmpName" placeholder="请输入申请人" clearable />
      </el-form-item>
      <el-form-item label="部门">
        <el-input v-model="params.ApplyDpName" placeholder="请输入部门" clearable />
      </el-form-item>
      
      <el-form-item label="请假时间" v-if="!isMB">
        <range-picker
          ref="picker"
          :date="[params.StartDate,params.EndDate]"
          @change="(x)=>{params.StartDate=x.Start;params.EndDate=x.End}"
        />
      </el-form-item>
      <template v-else>
        <el-form-item label="请假时间">
          <el-date-picker
            v-model="params.StartDate"
            type="date"
            value-format="yyyy/MM/dd"
            placeholder="开始日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label-width="85px">
          <el-date-picker
            v-model="params.EndDate"
            type="date"
            value-format="yyyy/MM/dd"
            placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
      </template>
      <el-form-item label-width="0" :style="isMB?'margin-left: 85px;':''">
        <span class="date-btn" @click="setDate('本周')">本周</span>
        <span class="date-btn" @click="setDate('本月')">本月</span>
        <span class="date-btn" @click="setDate('本学期')">本学期</span>
      </el-form-item>
      <el-form-item label="请假时长">
        <div style="display: flex;">
          <el-input class="num-range" v-model="params.StartDuration" v-int></el-input>
          <div style="display: inline-block;width: 5px;"></div>
          <el-input class="num-range" v-model="params.EndDuration" v-int></el-input>
        </div>
      </el-form-item>
      <el-form-item label="请假类型">
        <el-select v-model="params.LeaveType" clearable>
          <template v-for="(i,key) in LeaveTypes">
            <el-option :key="key" :label="i.LeaveTypeName" :value="i.LeaveTypeName"></el-option>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="销假状态">
        <el-select v-model="params.EndStatus" clearable>
          <el-option label="待销假" value="待销假"></el-option>
          <el-option label="已销假" value="已销假"></el-option>
        </el-select>
      </el-form-item>
    </template>
    <template slot="table">
      <el-table-column type="index" width="35" align="center" />
      <el-table-column type="expand" width="25" >
        <template slot-scope="{row}">事由：{{row.Reason}}</template>
      </el-table-column>
      <el-table-column prop="ApplyEmpName" label="申请人" min-width="70px" />
      <el-table-column prop="ApplyDpName" label="部门" min-width="65px" show-overflow-tooltip />
      <el-table-column label="起始" min-width="112px">
        <template slot-scope="{row}">
          <div>
            <span>{{$commonJs.toDateString(row.StartTime)}}</span>
            <span style="margin-left: 5px;">{{row.StartTimePart}}</span>
          </div>
          <div>
            <span>{{$commonJs.toDateString(row.EndTime)}}</span>
            <span style="margin-left: 5px;">{{row.EndTimePart}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="Duration" label="天数" />
      <el-table-column prop="LeaveType" label="请假类型" />
      <el-table-column prop="EndStatus" label="销假状态" align="center" width="80px">
        <template slot-scope="{row}">
          <span v-if="row.NeedEnd=='是'">{{row.EndStatus}}</span>
        </template>
      </el-table-column>
      <template v-if="!isMB">
        <el-table-column prop="CompleteTime" label="实际结束时间" min-width="120px">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.ActualEndTime)}}</span>
            <span style="margin-left: 5px;">{{row.ActualEndTimePart}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="Reason" label="请假事由" min-width="200px" /> -->
        <el-table-column prop="Files" label="附件" min-width="300px">
          <template slot-scope="{row}">
            <template v-for="(a,akey) in row.Files.split('--|--')">
              <span class="attach" :key="akey" @click="download(a)">{{a.split('--@--')[1]}}</span>
            </template>
          </template>
        </el-table-column>
      </template>
      <slot name="column"></slot>
    </template>
  </list>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/wf/wfleave").default,
      leave_type_api: require("@/api/ent/leaveType").default,
      params: {
        ApplyEmpName: "",
        LeaveType: "",
        StartDate: this.$commonJs.getToday(),
        EndDate: this.$commonJs.getToday(),
        Status: 2,
        EndStatus: "",
        StartDuration: null,
        EndDuration: null,
      },
      Term: {
        StartTime: "",
        EndTime: "",
      },
      LeaveTypes: [],
      isMB: this.$store.state.isMB,
    };
  },
  mounted() {
    this.leave_type_api.list({}).then((res) => {
      this.LeaveTypes = res.Data;
    });
  },
  methods: {
    setTerm(date) {
      this.Term.StartTime = date.StartTime;
      this.Term.EndTime = date.EndTime;
    },
    setDate(type) {
      var now_date = new Date();
      if (type == "本周") {
        var start = this.$dayjs(now_date).startOf("week").add(1, "day").$d;
        this.params.StartDate = start;
        var end = this.$dayjs(now_date).endOf("week").add(1, "day").$d;
        this.params.EndDate = end;
      }
      if (type == "本月") {
        var start = this.$dayjs(now_date).startOf("month").$d;
        this.params.StartDate = start;
        var end = this.$dayjs(now_date).endOf("month").$d;
        this.params.EndDate = end;
      }
      if (type == "本学期") {
        this.$nextTick(() => {
          this.params.StartDate = this.Term.StartTime;
          this.params.EndDate = this.Term.EndTime;
          console.log("this.Term", this.params);
        });
      }
    },
    download(item) {
      var url = item.split("--@--")[0];
      var name = item.split("--@--")[1];
      const elink = document.createElement("a");
      elink.download = name;
      elink.style.display = "none";
      elink.target = "_blank";
      elink.href = location.origin + "/api" + url;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
  },
};
</script>
<style lang="scss">
.num-range {
  width: 90px;
  .el-input__inner {
    width: 90px !important;
  }
}
.attach {
  color: #409eff !important;
  cursor: pointer;
}
.attach:not(:last-child)::after {
  content: "、";
}
.date-btn {
  color: #409eff;
  cursor: pointer;
}
.date-btn + .date-btn {
  margin-left: 5px;
}
</style>